<template>
  <div class="TrendLine">
    <div class="comTitle">
      <h4>用电趋势</h4>
      <div>
        <el-radio-group
          v-model="dataType"
          @change="changeDataType"
          size="mini"
          style="margin-right: 10px"
        >
          <el-radio-button label="电量">电量</el-radio-button>
          <el-radio-button label="电费">电费</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="lineType" @change="changeLineType" size="mini">
          <el-radio-button label="DAY">今日</el-radio-button>
          <el-radio-button label="MONTH">本月</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="comContentBox">
      <PublicEcharts
        v-if="!!assetId"
        :id="'distri'"
        :chartsData="chartsData"
        :type="'lightLine'"
        :options="getOptions()"
        usePropsOptions
      />
      <el-empty
        v-else
        class="empty"
        :image-size="50"
        description="暂无数据"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import PublicEcharts from "@/components/PublicEcharts.vue";
import { getXData, dealNumWith,dealBigNum } from "@/assets/js/utils";
export default {
  name: "TrendLine",
  props: {
    assetId: {
      type: String,
      default: "",
    },
  },
  components: { PublicEcharts },
  data() {
    return {
      dataType: "电量",
      lineType: "DAY",
      unit: "kw",
      xData: [],
      dataArr: [],
    };
  },
  computed: {
    chartsData: function () {
      return {
        title: "",
        unit: this.unit,
        xData: this.xData,
        dataArr: this.dataArr,
      };
    },
    xDataDefault: function () {
      const xdata = [24, this.$moment(new Date()).daysInMonth()];
      return this.lineType === "DAY"
        ? getXData(xdata, 0, 0)
        : getXData(xdata, 1, 1);
    },
  },
  methods: {
    initData() {
      this.xData = this.xDataDefault;
      this.dataArr = [];
      this.unit = "";
    },
    changeDataType() {
      this.getData();
    },
    changeLineType() {
      this.getData();
    },
    async getData() {
      this.initData();
      let res = await api.DSGetTrendChart({
        assetId: this.assetId,
        keyName: this.dataType,
        dateType: this.lineType,
      });
      if (res && res.data.code == 200) {
        const newXdata = [];
        const currentData = [];
        const prevData = [];
        Array.isArray(res.data.data) &&
          res.data.data.forEach((element, index) => {
            const { unit, time, value = [] } = element;
            if (index === 0) {
              this.unit = unit;
            }
            const newTime =
              this.lineType === "DAY"
                ? this.$moment(time).format("HH")
                : this.$moment(time).format("DD");
            newXdata.push(newTime);
            currentData.push(
              value?.[0]?.data ?? dealNumWith(value?.[0]?.data, 2)
            );
            prevData.push(value?.[1]?.data ?? dealNumWith(value?.[1]?.data, 2));
          });
        this.xData = newXdata;
        this.dataArr = [
          {
            name: this.lineType === "DAY" ? "今日" : "本月",
            data: currentData,
          },
          { name: this.lineType === "DAY" ? "昨日" : "上月", data: prevData },
        ];
      } else {
        console.log("获取趋势图表失败");
      }
    },
    getOptions() {
      const dateUnit = this.lineType === "DAY" ? "时" : "日"
      let that = this
      let option = {
        grid: {
          top: "60px",
          left: "80px",
          right: "45px",
          bottom: "30px",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let result = params[0].name +dateUnit+ "<br>";
            params.forEach(function (item) {
              result +=
                item.marker +
                ""+
                item.seriesName +
                " : " +
                dealBigNum(item.value) +
                that.chartsData.unit +
                "</br>";
            });
            return result;
          },
        },
        legend: {
          type: "scroll",
          top: "1%",
          right: "2%",
          textStyle: {
            color: "#333",
            fontSize: 12,
          },
        },
        xAxis: {
          type: "category",
          name: dateUnit,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
          },
          data: that.chartsData.xData,
        },
        yAxis: {
          type: "value",
          name: that.chartsData.unit ? `单位(${that.chartsData.unit})` : "",
          nameTextStyle: {
            color: "#666",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          axisLabel: {
            color: "#999",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "#EBEBEB",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };
      that.chartsData.dataArr.forEach((v, i) => {
        option.series.push({
          name: v.name,
          data: v.data,
          type: that.chartsData.type ?? "line",
          symbolSize: v.name == "国家指标" || v.name == "单位指标" ? 0 : 6,
          itemStyle: {
            color: EchartsLightColor[i],
          },
          animation: true,
        });
      });

      return option;
    },
  },
  watch: {
    assetId() {
      this.getData();
    },
  },
  created() {},
  mounted() {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.TrendLine {
  width: 100%;
  height: 100%;
}
</style>
